/**
 * PageHeader — the h1 + optional subtitle that opens each page.
 */
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
}

export function PageHeader({ title, subtitle, className }: PageHeaderProps) {
  return (
    <div className={className}>
      <h1 className="text-[26px] font-bold tracking-[-0.02em]">{title}</h1>
      {subtitle && <p className="mt-1.5 text-[15px] text-muted-foreground">{subtitle}</p>}
    </div>
  );
}
